<script>
  import {onDestroy} from 'svelte';
  import {templateFontStore} from '../../../../services/animation/font-loader';
  import FontBlock from './FontBlock.svelte';
  let fonts = [];
  const unsubscribe = templateFontStore.subscribe(store => {
    fonts = [];
    fonts = store;
  });
  onDestroy(unsubscribe);
</script>

<div id="font_select" class="grid grid-cols-2 gap-8 py-1">
  {#each fonts as font, index ({font, index})}
    <FontBlock {font} primary={index === 0} />
  {/each}
</div>

<style lang="postcss">
</style>
